/*
 * MAIN SCRIPT
 * DON'T WRITE FUNCTION HERE, ONLY CALL THEM
 *
 * **/
document.addEventListener('DOMContentLoaded', (event) => {
    initFormsValidation();
    initModalResponse();
    initIubendaProof();
    jsLazyLoadImages();
    initSwitchLanguage();
    initGallerySlider();
    initWideGallerySlider();
    initMobileMenu();
    initCardDeckMobileSlider();
    initMapScript();
    initFormFieldsToggle();
    initLoadMore();
    initHeadingVideo();
    initSidebar();
});
